import { useEffect } from "react";

import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { AllOutletsSelect, OutletRoleEnum } from "@/features/outlets";
import { CustomDatePicker, CustomInputField } from "@/features/ui";

export const GeneralInformationSection = () => {
  const { control, register, watch, setValue } = useFormContext();

  const seller = watch("seller");

  useEffect(() => {
    if (seller?.supplierTaxInformation) {
      setValue("taxable", seller.supplierTaxInformation.defaultTaxIncluded);
    }
    if (seller?.defaultPaymentTerm) {
      setValue("paymentTerm", seller.defaultPaymentTerm);
    }
  }, [seller, setValue]);

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="seller"
            render={({ field, fieldState }) => (
              <AllOutletsSelect
                value={field.value}
                onChange={field.onChange}
                allowedRoles={[OutletRoleEnum.HUB]}
                TextFieldProps={{
                  label: "Pemasok",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <CustomInputField
            control={control}
            register={register}
            name="buyer.name"
            label="Pembeli"
            required
            disabled={true}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <CustomInputField
            control={control}
            register={register}
            name="customer.name"
            label="Pelanggan"
            required
            disabled={true}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.error}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
